import { useSendInfo, useSendNftInfo } from '@/store/zustand/store';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';

import TopBackButton from '@/component/common/top-back-button';
import { ShortenTxId } from '@/lib/Shorten';
import { Erc721TokenProps } from './Erc721Token';

function erc721Form({ contractAddr, tokenId }: { contractAddr: string; tokenId: string }) {
  return (
    <Grid container spacing={1} mb={4}>
      <Grid item xs={6} style={{ fontWeight: '700', textAlign: 'left' }}>
        token id: {tokenId}
      </Grid>
      <Grid item xs={6} style={{ textAlign: 'right' }}>
        컨트랙트: {ShortenTxId(contractAddr)}
      </Grid>
    </Grid>
  );
}

function otherForm({ amount, symbol }: { amount: string; symbol: string }) {
  return (
    <>
      <Grid container spacing={1} mb={4}>
        <Grid item xs={4}>
          금액
        </Grid>
        <Grid item xs={8} style={{ fontWeight: '700', textAlign: 'right' }}>
          {amount} {symbol}
        </Grid>
      </Grid>
    </>
  );
}

type comfirmSendProps = {
  type: 'base' | 'erc20' | 'erc721';
  symbol: string;
};
export default function ComfirmSend(aPayload: comfirmSendProps) {

  const { type, symbol } = aPayload;
  const sendNftInfo = useSendNftInfo() as unknown as Erc721TokenProps;
  const sendInfo = useSendInfo();
  return (
    <>
      <Box>
        <Container
          maxWidth="sm"
          sx={{
            position: 'relative',
          }}
        >
          <TopBackButton
            title="확인"
            boxProps={{
              mb: 4,
            }}
            backPath="/wallet"
          />
          <Typography variant="body1" mb={1}>
            <b>From</b>
          </Typography>
          <TextField disabled fullWidth defaultValue={type === 'erc721' ? sendNftInfo.fromAddr : sendInfo.from} />
          <Box mb={2} />
          <Typography variant="body1" mb={1}>
            <b>TO</b>
          </Typography>
          <TextField
            disabled
            fullWidth
            defaultValue={type === 'erc721' ? sendNftInfo.toAddr : sendInfo.to}
            // InputProps={{
            //   endAdornment: (
            //     <InputAdornment position="end">
            //       <Button
            //         onClick={() => {
            //           qr_camera_call();
            //         }}
            //       >
            //         <ImgCam />
            //       </Button>
            //     </InputAdornment>
            //   ),
            // }}
          />
          <Box mb={4} />
          <Stack
            borderRadius={2}
            bgcolor="#F5F5F5"
            alignItems="center"
            justifyContent="space-between"
            px={3}
            py={5}
            direction="row"
            spacing={{ xs: 1, sm: 2, md: 4 }}
          >
            {type === 'erc721'
              ? erc721Form({ contractAddr: sendNftInfo.contract, tokenId: sendNftInfo.tokenId })
              : otherForm({ amount: sendInfo.value, symbol })}
          </Stack>
          {/* {isWeb3 ? (
            ''
          ) : (
            <>
              ※ <strong>보내기</strong> 클릭 후 메타마스크 앱이 앱이 자동 실행되지 않을 경우, <br />
              <br />
              메타마스크 앱을 직접 실행하시고 잠시 기다리면 <br />
              <br />
              메타마스크의 <strong>컨펌</strong> 버튼이 활성화 됩니다.
            </>
          )} */}
        </Container>
      </Box>
    </>
  );
}
